export const SEARCH_PLAYER_LIST = 'SEARCH_PLAYER_LIST';
export const SEARCH_AFFILIATE_LIST = 'SEARCH_AFFILIATE_LIST';
export const SEARCH_DEPOSIT_LIST = 'SEARCH_DEPOSIT_LIST';
export const SEARCH_WITHDRAWAL_LIST = 'SEARCH_WITHDRAWAL_LIST';

export const SEARCH_LIST_SUCCESS = 'SEARCH_LIST_SUCCESS';
export const SEARCH_LIST_FAIL = 'SEARCH_LIST_FAIL';

export const RESET_SEARCH_LIST_ERRORS = 'RESET_SEARCH_LIST_ERRORS';
